import {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  SelectWrapper,
  InputTextWrapper,
  InputNumberWrapper,
  InputDateWrapper,
} from '../../../../../../components/UI/Form/Input'
import HeaderTitle from '../../../componentes/Form/Header'
import {getInspectById, getPoint, getSupplier} from '../../../../services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import {InspectModel, PointModel, SelectModel, SupplierModel} from '../../../../model'
import {TITLE_FORM_INSPECT} from '../../../../util/Constants'
import {initValues} from '../../../../util/values/inspect'
import {useCompany, useClient, useSite} from '../../../../../central/hooks'
import {clearFields} from '../../../../../../util/functions'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import {useTableMaster} from '../../../../hooks'
const meetsStandar = [
  {
    value: 'SI',
    label: 'SI',
  },
  {
    value: 'NO',
    label: 'NO',
  },
]
const Inspect: FC = () => {
  const {setError, setValue, watch, reset} = useFormContext()
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [supplier, setSupplier] = useState<SelectModel[]>([])
  const [point, setPoint] = useState<SelectModel[]>([])
  const [isSupplier, setIsSupplier] = useState<boolean>(false)
  const [isPoint, setIsPoint] = useState<boolean>(false)
  const {
    inspectionScope,
    getInspectionScopeList,
    typeInspect,
    getTypeInspectList,
    getTypeAdminList,
    typeAdmin,
  } = useTableMaster()
  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()

  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    if (response.length === 1) {
      setValue('companiaId', response[0].value)
      setError('companiaId', {})
      await getClientList(response[0].value as string)
    }

    setCompany(response)
  }
  const getClientList = async (companyId: string) => {
    const response = await getClientFD({companiaId: companyId})
    if (response.length === 1) {
      setValue('clienteId', response[0].value)
      setError('clienteId', {})
      await getSiteList(response[0].value as string)
    }
    setClients(response)
  }
  const getSiteList = async (clientId: string) => {
    const response = await getSiteFD({clienteId: clientId})
    if (response.length === 1) {
      setValue('siteId', response[0].value)
      setError('siteId', {})
    }
    setSites(response)
  }

  const getSupplierList = async () => {
    let obj: SupplierModel = {
      isCombo: true,
    }
    const response = await getSupplier(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.razonSocial, ...item}))
    setSupplier(mappedSites)
  }

  const getPointList = async () => {
    let obj: PointModel = {
      isCombo: true,
      companiaId: watch('companiaId'),
      clienteId: watch('clienteId'),
      siteId: watch('siteId'),
    }
    const response = await getPoint(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: item.nombre,
      typeAdmin: item.tipoAdministracion,
    }))
    setPoint(mappedSites)
  }

  const getInspectByIdValues = async () => {
    const response = await getInspectById(currentTabItem.idToEdit)
    const data = response.data.data
    data.cumpleEstandar = data.cumpleEstandar ? 'SI' : 'NO'
    type InspectModelKeys = keyof InspectModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as InspectModelKeys]) {
            if (fieldName === 'clienteId') {
              let valueCompania = data['companiaId']
              let valueClient = data['clienteId']
              getClientList(valueCompania as any)
              setValue('clienteId', valueClient)
            } else if (fieldName === 'siteId') {
              let valueSite = data['siteId']
              let valueClient = data['clienteId']
              getSiteList(valueClient as any)
              setValue('siteId', valueSite)
              getPointList()
            } else if (fieldName === 'fechaProgramacion') {
              let valueDep = data[fieldName as InspectModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'fechaEjecutada') {
              let valueDep = data[fieldName as InspectModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'tipoAdministracion') {
              let valueDep = data[fieldName as InspectModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                setValue(fieldName, valueDep.toUpperCase())
                if (valueDep.toUpperCase() === 'EXTERNO') {
                  setIsSupplier(true)
                } else {
                  setIsPoint(true)
                }
              }
            } else if (fieldName === 'campoadicionalFec1') {
              let valueDep = data[fieldName as InspectModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'campoadicionalFec2') {
              let valueDep = data[fieldName as InspectModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else {
              setValue(fieldName, data[fieldName as InspectModelKeys])
            }
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }

  useEffect(() => {
    getCompanyList()
    getTypeInspectList()
    getInspectionScopeList()
    getSupplierList()
    getTypeAdminList()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getInspectByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
    }
    reset()
    changeCurrentTabItem(obj)
  }

  const handleGetClient = (e: any) => {
    let value = e.value
    getClientList(value)
    setValue('companiaId', value)
    setError('companiaId', {})
    clearFields(setValue, setError, {
      clienteId: '',
      siteId: '',
    })
  }
  const handleGetSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    setValue('clienteId', value)
    setError('clienteId', {})
    clearFields(setValue, setError, {
      siteId: '',
    })
  }

  const handleGetPoint = (e: any) => {
    let value = e.value
    setValue('siteId', value)
    setError('siteId', {})
    getPointList()
  }
  const handleGetTypeAdmin = (e: any) => {
    let value = e.value
    setValue('tipoAdministracion', value)
    setError('tipoAdministracion', {})
    setValue('puntoId', null)
    setValue('proveedorId', null)

    if (value === 'EXTERNO') {
      setIsPoint(false)
      setIsSupplier(true)
    } else {
      setIsSupplier(false)
      setIsPoint(true)
    }
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_form card p-4'>
      <HeaderTitle title={TITLE_FORM_INSPECT} handleBack={handleBack} />
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Compañía'
            name='companiaId'
            data={company}
            disabled={isDisabled}
            onChangeValue={handleGetClient}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='clienteId'
            data={clients}
            disabled={isDisabled}
            onChangeValue={handleGetSite}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Site'
            name='siteId'
            data={sites}
            disabled={isDisabled}
            onChangeValue={handleGetPoint}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Código de inspección'
            name='codigoInspeccion'
            textPlaceholder='Escribe la nomenclatura'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de inspección'
            name='tipoInspeccion'
            data={typeInspect}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputDateWrapper labelText='Fecha programada' name='fechaProgramacion' required />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputDateWrapper labelText='Fecha ejecutada' name='fechaEjecutada' />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Porcentaje obtenido'
            type='decimal'
            name='porcentaje'
            textPlaceholder='porcentaje obtenido'
            maxLength={100}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='¿Cumple estándar?'
            name='cumpleEstandar'
            data={meetsStandar}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Alcance de inspección'
            name='alcanceInspeccion'
            data={inspectionScope}
            required
          />
        </div>

        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de administración'
            name='tipoAdministracion'
            data={typeAdmin}
            onChangeValue={handleGetTypeAdmin}
            required
          />
        </div>
        {isSupplier && (
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper labelText='Proveedor' name='proveedorId' data={supplier} required />
          </div>
        )}
        {isPoint && (
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper labelText='Punto de Lavandería' name='puntoId' data={point} required />
          </div>
        )}
      </div>
      <hr className='divider' />
      <AditionalForm />
    </div>
  )
}

export default Inspect
